// src/components/Keypad.js
import React from 'react';

function Keypad({ onKeyPress, mathMode }) {
    // Determine button order based on math mode
    const isSubtraction = mathMode === 'subtraction';
    const isDivision = mathMode === 'division';
    
    // This logic mimics the original CSS class switching
    const row4Class = isSubtraction ? "keypad-row row-4 subtraction-mode" : 
                      isDivision ? "keypad-row row-4 division-mode" : "keypad-row row-4";

    return (
        <div className={`keypad ${isSubtraction ? 'mode-subtraction' : ''} ${isDivision ? 'mode-division' : ''}`}>
            <div className="keypad-row">
                <button onClick={() => onKeyPress('1')} className="keypad-btn number-btn">1</button>
                <button onClick={() => onKeyPress('2')} className="keypad-btn number-btn">2</button>
                <button onClick={() => onKeyPress('3')} className="keypad-btn number-btn">3</button>
            </div>
            <div className="keypad-row">
                <button onClick={() => onKeyPress('4')} className="keypad-btn number-btn">4</button>
                <button onClick={() => onKeyPress('5')} className="keypad-btn number-btn">5</button>
                <button onClick={() => onKeyPress('6')} className="keypad-btn number-btn">6</button>
            </div>
            <div className="keypad-row">
                <button onClick={() => onKeyPress('7')} className="keypad-btn number-btn">7</button>
                <button onClick={() => onKeyPress('8')} className="keypad-btn number-btn">8</button>
                <button onClick={() => onKeyPress('9')} className="keypad-btn number-btn">9</button>
            </div>
            <div className={row4Class}>
                <button onClick={() => onKeyPress('-')} className="keypad-btn action-btn minus-btn" style={{display: isSubtraction ? 'flex' : 'none'}}>−</button>
                <button onClick={() => onKeyPress('.')} className="keypad-btn action-btn decimal-btn" style={{display: isDivision ? 'flex' : 'none'}}>.</button>
                <button onClick={() => onKeyPress('0')} className="keypad-btn number-btn">0</button>
                <button onClick={() => onKeyPress('C')} className="keypad-btn action-btn clear-btn">C</button>
                <button onClick={() => onKeyPress('Go')} className="keypad-btn action-btn go-btn" style={{display: isSubtraction || isDivision ? 'none' : 'flex'}}>Go</button>
            </div>
            <div className="keypad-row keypad-row-5" style={{display: isSubtraction || isDivision ? 'flex' : 'none'}}>
                <button onClick={() => onKeyPress('Go')} className="keypad-btn action-btn go-btn-alt">Go</button>
            </div>
        </div>
    );
}

export default Keypad;